import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React , {useEffect} from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useShowQuestionOptionQuery,useUpdateQuestionOptionMutation,useGetCourseListQuery} from "../../../Services/api";
export default function UpdateStudent(props) {
    const notify = () => '';
    const validationSchema = Yup.object().shape({
        question_id: Yup.string().required("question fields is required"),
        multiple_choice: Yup.string().required("Option title is required"),
        multiple_choice_answer: Yup.string().required("answer  fields is required"),
    });
      const {
        data: ShowQuestionOption,
      } =useShowQuestionOptionQuery({  params:props['id']});

      const [UpdateQuestionOption,isLoading] = useUpdateQuestionOptionMutation();
      const getOption= ShowQuestionOption?.data[0];
      var  defaultValues={
            question_id:getOption?.question?.question_name,
            multiple_choice:getOption?.multiple_choice,
            multiple_choice_answer:getOption?.multiple_choice_answer,
       };
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues: defaultValues,
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
      } = methods;
       // eslint-disable-next-line react-hooks/exhaustive-deps 
      useEffect(() => {
        reset(defaultValues)
      },[getOption]) 
      
    const updateQuestionOptionList = (values,e) => {
        UpdateQuestionOption({ data: values,param:props['id'] })
        .unwrap()
        .then((payload) => {
            if (payload.status) {
              toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    const { 
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    return (
        
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Question Option</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                        <h5 className="card-title">Update Question Option</h5>
                        <form onSubmit={handleSubmit(updateQuestionOptionList)} >
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Question name</label>
                            <div className="col-sm-10">
                                <select  {...register("question_id")} className="form-control" >
                                    <option value={getOption?.question?.id}>{getOption?.question?.question_name}</option>  
                                </select>
                                <span className="text-danger">{errors.multiple_choice_answer?.message}</span>
                            </div>
                        </div>
                       
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Question Options Name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("multiple_choice")} className="form-control" />
                                <span className="text-danger">{errors.multiple_choice?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Element</label>
                            <div className="col-sm-10">
                                <select  {...register("multiple_choice_answer")} className="form-control" >
                                 <option value="0">Correct</option>                                           
                                 <option value="1">Incorrect</option>  
                                </select>
                                <span className="text-danger">{errors.multiple_choice_answer?.message}</span>
                            </div>
                        </div>
                      
                        <div className="modal-footer">
                             {isLoading.status !='pending' ? 
                                  <>
                                     <button type="submit" className="btn btn-warning">Save changes</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                  </>        
                                :
                                <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                              }
                                

                            </div> 
                        </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    );
}